import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@ui/dialog.tsx';
import { Button } from '@ui/button.tsx';
import { CreateGameForm } from '@admin/components/games/create-game-form.tsx';

interface CreateGameDialogProps {
  onCreated: () => void;
}

/** Modale de création d'un jeu, avec le bouton déclencheur. */
export const CreateGameDialog: FC<CreateGameDialogProps> = ({ onCreated }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleSuccess = () => {
    setIsOpen(false);
    onCreated();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button rounded="full">
          {t('games.create.submit')} <Plus />
        </Button>
      </DialogTrigger>

      <DialogContent className="p-14 max-w-2xl max-h-[90vh] overflow-y-auto scrollable">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t('games.create.submit')}</DialogTitle>
        </DialogHeader>
        <div className="mt-6">
          <CreateGameForm onSuccess={handleSuccess} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
